import React, { useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { getDate, replace } from '../../../../utils/func';
import styles from './Order.module.scss';
import { Button } from 'react-bootstrap';
import OrderItemPrice from '../../../../components/OrderItemPrice/OrderItemPrice';

const PRODUCT_ROUTE = 'products/item/';

const Order = ({ order }) => {
  const [active, setActive] = useState(false);
  const [height, setHeight] = useState('0px');
  const content = useRef(null);

  const {
    status,
    firstName,
    email,
    phone,
    lastName,
    orderNo,
    date,
    totalSum,
    paymentMethod,
    paymentInfo,
    deliveryAddress,
    products,
  } = order;

  const normalizedTotalSum =
    typeof totalSum === 'object'
      ? Number(totalSum.$numberDecimal)
      : Number(totalSum || 0);

  const isMonoCredit = paymentMethod === 'MonoCredit';

  const partsCount = Number(paymentInfo?.partsCount || 0);

  const monthlyPayment = paymentInfo?.monthlyPayment
    ? Number(paymentInfo.monthlyPayment)
    : partsCount
      ? normalizedTotalSum / partsCount
      : 0;

  const typePayment = isMonoCredit
    ? 'Оплата частинами monobank'
    : paymentMethod;

  const statusColors = {
    specified: { color: '#FF0000', text: 'Уточнюється' },
    processed: { color: '#FF8C00', text: 'Обробляється' },
    send: { color: '#0000FF', text: 'Відправлено' },
    completed: { color: '#008000', text: 'Виконано' },
    abolition: { color: 'red', text: 'Відмінено' },
    payment_failed: { color: 'red', text: 'Оплата не пройшла' },
  };

  const statusElement = (
    <p style={{ color: statusColors[status]?.color || 'black' }}>
      {statusColors[status]?.text || 'Невідомий статус'}
    </p>
  );

  const toggleDescription = () => {
    setActive(!active);
    setHeight(active ? '0px' : `${content.current.scrollHeight}px`);
  };

  const orderedProducts = products.map((orderItem) => (
    <article key={orderItem.product._id} className={styles.productItem}>
      {!orderItem.product.itsBottle && (
        <NavLink
          to={`/${PRODUCT_ROUTE}${orderItem.product._id}`}
          className={styles.productLink}
        >
          <img
            src={orderItem.product.imageFirst}
            width={100}
            alt={`${orderItem.product.name}`}
          />
        </NavLink>
      )}

      <div className={styles.productDescription}>
        <NavLink
          to={`/${PRODUCT_ROUTE}${orderItem.product._id}`}
          className={styles.productLink}
        >
          {orderItem.product.itsBottle ? 'Флакон' : orderItem.product.name}
        </NavLink>

        <OrderItemPrice orderItem={orderItem} />

        <p>
          К-ть:{' '}
          {orderItem.product.bottling ? (
            <span className={styles.bold}>
              {Math.floor(orderItem.cartQuantity) + 1}{' '}
              {orderItem.product.itsBottle ? 'шт.' : 'мл.'}
            </span>
          ) : (
            <span className={styles.bold}>{orderItem.cartQuantity} шт.</span>
          )}
        </p>
      </div>
    </article>
  ));

  return (
    <section className={`${styles.orderWrapper} ${active ? styles.active : ''}`}>
      <header className={styles.orderHeader}>
        <div>Замовлення №{orderNo}</div>

        <div>
          <p>
            {replace(
              typeof totalSum === 'object' ? totalSum.$numberDecimal : totalSum
            )}{' '}
            грн
          </p>
        </div>
      </header>

      <div className={styles.orderDetails}>
        <div>
          {products.map((orderItem) => (
            <p key={orderItem.product._id} className={styles.productName}>
              {orderItem.product.itsBottle ? 'Флакон' : orderItem.product.name}
            </p>
          ))}
        </div>

        <div>
          <span className={styles.date}>Дата замовлення: {getDate(date)}</span>
        </div>

        <div className={styles.buttonWrapper}>
          <Button variant="dark" onClick={toggleDescription}>
            Детальна інформація
          </Button>
        </div>
      </div>

      <div ref={content} style={{ height }} className={styles.orderDescription}>
        <hr />

        <section className={styles.userDataTable}>
          <div className={styles.tableRow}>
            <p className={styles.tableRowTitle}>Статус</p>
            {statusElement}
          </div>

          <div className={styles.tableRow}>
            <p className={styles.tableRowTitle}>Ім'я та прізвище</p>
            <p>{`${firstName} ${lastName}`}</p>
          </div>

          <div className={styles.tableRow}>
            <p className={styles.tableRowTitle}>Електронна пошта</p>
            <p>{email}</p>
          </div>

          <div className={styles.tableRow}>
            <p className={styles.tableRowTitle}>Номер телефону</p>
            <p>{phone}</p>
          </div>

          <div className={styles.tableRow}>
            <p className={styles.tableRowTitle}>Місто</p>
            <p style={{ color: deliveryAddress?.city ? 'inherit' : 'red' }}>
              {deliveryAddress?.city || 'Місто не вказане'}
            </p>
          </div>

          <div className={styles.tableRow}>
            <p className={styles.tableRowTitle}>Область</p>
            <p style={{ color: deliveryAddress?.region ? 'inherit' : 'red' }}>
              {deliveryAddress?.region || 'Область не вказана'}
            </p>
          </div>

          <div className={styles.tableRow}>
            <p className={styles.tableRowTitle}>Адреса</p>
            <p style={{ color: deliveryAddress?.address ? 'inherit' : 'red' }}>
              {deliveryAddress?.address || 'Адреса не вказана'}
            </p>
          </div>

          <div className={styles.tableRow}>
            <p className={styles.tableRowTitle}>Спосіб доставки</p>
            <p style={{ color: deliveryAddress?.delivery ? 'inherit' : 'red' }}>
              {deliveryAddress?.delivery || 'Спосіб доставки не вказаний'}
            </p>
          </div>

          <div className={styles.tableRow}>
            <p className={styles.tableRowTitle}>Спосіб оплати</p>
            <p>{typePayment}</p>
          </div>

          {isMonoCredit && (
            <>
              <div className={styles.tableRow}>
                <p className={styles.tableRowTitle}>Кількість платежів</p>
                <p>{partsCount || 'Не вказано'}</p>
              </div>

              {partsCount > 0 && (
                <div className={styles.tableRow}>
                  <p className={styles.tableRowTitle}>Щомісячний платіж</p>
                  <p>{replace(monthlyPayment.toFixed(2))} грн</p>
                </div>
              )}

              {paymentInfo?.state && (
                <div className={styles.tableRow}>
                  <p className={styles.tableRowTitle}>Статус оплати</p>
                  <p>
                    {paymentInfo.state}
                    {paymentInfo.orderSubState
                      ? ` / ${paymentInfo.orderSubState}`
                      : ''}
                  </p>
                </div>
              )}

              <div className={styles.tableRow}>
                <p className={styles.tableRowTitle}>Умови</p>
                <p>
                  Перший платіж списується під час оформлення покупки.
                  Наступні платежі — щомісячно рівними частинами.
                </p>
              </div>
            </>
          )}
        </section>

        <section className={styles.productPreview}>
          <h2>Ваше замовлення</h2>
          <hr />

          {orderedProducts}

          <p className={styles.totalPrice}>
            Разом до оплати:{' '}
            {replace(
              typeof totalSum === 'object' ? totalSum.$numberDecimal : totalSum
            )}{' '}
            грн
          </p>
        </section>
      </div>
    </section>
  );
};

export default Order;